document.addEventListener("DOMContentLoaded", function () {
  const togglePassword = document.getElementById("toggle-password");
  const passwordField = document.querySelector(".password-field");

  if (togglePassword) {
    togglePassword.addEventListener("click", function () {
      const type =
        passwordField.getAttribute("type") === "password" ? "text" : "password";
      passwordField.setAttribute("type", type);
    });
  }

  /* Toogle Login/Forgot */
  const forgotLink = document.querySelector(".customer__forgot-password");
  if (forgotLink) {
    forgotLink.addEventListener("click", function (e) {
      e.preventDefault();
      document.querySelector(".login-container").classList.toggle("hidden");
      document.querySelector(".recover-container").classList.toggle("hidden");
      const bodyElement = document.querySelector("body");
      bodyElement.scrollIntoView({ behavior: "smooth" });
    });
  }

  const forgotCancel = document.querySelector(
    ".recover-container .customer__cancel",
  );
  if (forgotCancel) {
    forgotCancel.addEventListener("click", function (e) {
      e.preventDefault();
      document.querySelector(".recover-container").classList.toggle("hidden");
      document.querySelector(".login-container").classList.toggle("hidden");
      const bodyElement = document.querySelector("body");
      bodyElement.scrollIntoView({ behavior: "smooth" });
    });
  }
});
